import { useState, useEffect } from 'react';

/**
 * wrapper around useState that exposes the actual state value as a mutable
 * ref, which is useful if we need to be able to access the current value
 * outside the render cycle, but also want changes to trigger re-rendering.
 */
function useMicroInteraction(options) {
  const [enabled, setEnabled] = useState(options.isEnabledInitially ?? false);
  const enableInteraction = () => {
    if (enabled) {
      return;
    }
    setEnabled(true);
  };
  useEffect(() => {
    if (!enabled) {
      return;
    }
    const timeout = window.setTimeout(() => {
      setEnabled(false);
    }, options.durationMs);
    return () => {
      window.clearTimeout(timeout);
    };
  }, [enabled, options.durationMs]);
  return [enabled, enableInteraction];
}

export { useMicroInteraction };
//# sourceMappingURL=micro-interaction.js.map
